export default {
  emailOrPhone: '电子邮件或电话',
  password: '密码',
  rememberMe: '记住我',
  forgotYourPassword: '忘记密码？',
  signIn: '登录',
  newHere: '新来？',
  openAccount: '开立账户',
  haveAccount: '已经有帐户了？',
  fullName: '全名',
  country: '国家',
  phone: '电话',
  email: '电子邮件',
  iAgree: '我同意',
  termsAndConditions: '条款和条件协议',
  signUp: '登记',
  recoverPassword: '恢复密码',
  recover: '恢复',
  goBack: '回去',
  weHaveSentYouACode: '我们向您发送了一个代码给您的',
  receivedCode: '收到的代码',
  newPassword: '新密码',
  confirmNewPassword: '确认您的新密码',
  passwordSuccessfullyChanged: '已成功更改密码'
}
